import styled from 'styled-components'
import Link from '../links/link'
import Button from './button'

export default styled(Button.withComponent(Link))``
